import { apiClient } from '../lib/api';

export interface QuoteRequest {
    provider?: string;
    destination_location: {
        address: string;
        city: string;
        contact_name: string;
        contact_phone: string;
        latitude: number;
        longitude: number;
    };
    order_uuid: string | null;
}

export interface QuoteResponse {
    uuid: string;
    price: string;
    provider: string;
    expires_at: string;
}

export const shipmentService = {
    getQuote: async (data: QuoteRequest): Promise<QuoteResponse> => {
        return apiClient.request<QuoteResponse>('/shipments/quotes/', {
            method: 'POST',
            body: JSON.stringify(data),
        });
    },
};
